import { createAction } from 'redux-act';

export const getCalendarReports = createAction('get calendar reports');
export const setCalendarReports = createAction('set plans');
